import {
    POST_ACTIVATION_CODE_START,
    POST_ACTIVATION_CODE_FAIL,
    POST_ACTIVATION_CODE,
    ACTIVATION_CODE_INFO_CHANGED
} from '../../actions/types';

const INITIAL_STATE = {
    error: '',
    loading: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ACTIVATION_CODE_INFO_CHANGED:
            return { ...state, [action.payload.props]: action.payload.value };
        case POST_ACTIVATION_CODE_START:
            return { ...state, loading: true };
        case POST_ACTIVATION_CODE_FAIL:
            return { ...state, loading: false, error: { email: action.payload } };
        case POST_ACTIVATION_CODE:
            return { ...state, ...INITIAL_STATE };
        default:
            return state;
    }
};

